module.exports = __webpack_public_path__ + "img/RORBPJR40066.521ddbf2.png";